import React from 'react'
import PropTypes from 'prop-types'

const AlternateGrid = props => {
  const items = []
  for (let i = 0; i < props.items.length; ++i) {
    let item = props.items[i]
    item.key = i
    if (i % 2 === 0) {
      items.push(React.createElement(props.first, item, null))
    } else {
      items.push(React.createElement(props.second, item, null))
    }
  }
  return <>{items}</>
}

AlternateGrid.propTypes = {
  first: PropTypes.func.isRequired,
  second: PropTypes.func.isRequired,
  item: PropTypes.array,
}

export default AlternateGrid
